<template>
  <textarea
    :class="[
      ...colors,
      !resize && 'resize-none',
      'shadow-sm border rounded w-full max-min-size py-2 px-3 text-sm leading-tight',
    ]"
    :id="id"
    :placeholder="placeholder"
    v-model="model"
  />
</template>

<script>
  export default {
    name: 'BaseTextarea',

    props: {
      id: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: '',
      },
      resize: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      model: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },

      colors() {
        if (this.hasError) {
          return ['border-red-300', 'focus:border-red-500'];
        }

        return [
          'outline-none',
          'border-metallicSilver',
          'hover:border-darkCharcoal',
          'focus:border-darkCharcoal focus:shadow-outline--maximumBluePurple',
        ];
      },
    },
  };
</script>

<style scoped>
  .max-min-size {
    min-height: 3rem;
    max-height: 10rem;
  }
  .focus\:shadow-outline--maximumBluePurple:focus {
    box-shadow: 0 0 0 3px rgba(157, 169, 242, 0.5);
  }
  textarea[disabled] {
    background-color: #D9D9DE;
    cursor: not-allowed;
  }
  .resize-none {
    resize: none;
  }
</style>
